import { useIntl } from "react-intl";

import SadFace from "~/hec/assets/icons/sad-face";
import { BodyCopy } from "~/hec/components/ui/body-copy";
import { Heading } from "~/hec/components/ui/heading";

import messages from "./messages";

/**
 * SFCC-11505 — port of composable `failedQuizBlock.jsx`. The retry-prompt state
 * shown in the quiz accordion panel after a failing submission.
 */
const FailedQuizBlock = () => {
  const intl = useIntl();
  return (
    <div
      className="flex flex-col items-center rounded-md bg-red-01/30 py-[3.25rem]"
      data-testid="failedQuizBlock"
    >
      <SadFace />
      <Heading
        tag="h4"
        variant="h4"
        className="mb-2 mt-5 text-emphasis"
        data-testid="failedQuizBlock-Heading"
      >
        {intl.formatMessage(messages.quizFailedHeading)}
      </Heading>
      <BodyCopy
        size="large"
        className="text-emphasis"
        data-testid="failedQuizBlock-BodyCopy"
      >
        {intl.formatMessage(messages.quizFailedBody)}
      </BodyCopy>
    </div>
  );
};

export default FailedQuizBlock;
